var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-form"
  }, [(_vm.errors.length > 0) ? _c('div', {
    staticClass: "error-messages"
  }, [_c('p', {
    staticClass: "message-error ss-alert"
  }, [_vm._v(_vm._s(_vm.errors.join(', ')))])]) : _vm._e(), _vm._v(" "), (_vm.showingForm) ? _c('form', [_vm._t("fields"), _vm._v(" "), _c('input', {
    staticClass: "cm-button small",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.I18n.t('save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveForm($event)
      }
    }
  })], 2) : _c('div', {
    staticClass: "inline-form__content"
  }, [_vm._t("default"), _vm._v(" "), (_vm.editable) ? _c('button', {
    staticClass: "edit-button ss-icon",
    on: {
      "click": _vm.showForm
    }
  }, [_vm._v("compose")]) : _vm._e()], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17bb7db6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/inline-form.vue
// module id = null
// module chunks = 